import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { formatDate } from '@/utils/dateHelper';
import {
  columnDate,
  columnStatus,
  columnTools,
  hasColumn,
} from '@/constants/fields';
import { dataModelReportsEndpoint } from '@/constants/urls';
import { states } from '@/constants/lifecycle';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import SimpleCell from '@/components/table/SimpleCell';
import { dataModelReportDownload } from '../actions';
import { findDataModelReport } from '../helper';
import DataModelValidationStatusCell from '../components/DataModelValidationStatusCell';
import DataModelReportToolsMenu from '../components/DataModelReportToolsMenu';

const DataModelReportsTableRow = ({
  category,
  code,
  upward,
  downloadStart,
  isDownloading,
  columns,
  reportId,
  reportName,
  reportDate,
  validationStatus,
}) => (
  <NameDescriptionRow
    asHref
    columns={columns}
    disabled={isDownloading}
    href={dataModelReportsEndpoint(code, reportId)}
    icon="file"
    nameMessageId={isDownloading ? 'icon.download.preparing' : 'icon.datamodel.validation.report'}
    loading={isDownloading}
    name={reportName}
    onClick={() => downloadStart('downloads', code, { id: reportId, name: reportName }, true)}
  >
    {hasColumn(columns, columnDate) && (<SimpleCell content={reportDate ? formatDate(reportDate) : null} />)}
    {hasColumn(columns, columnStatus) && (<DataModelValidationStatusCell status={validationStatus} />)}
    {hasColumn(columns, columnTools) && (
      <Table.Cell collapsing>
        <DataModelReportToolsMenu
          category={category}
          code={code}
          downloadStart={downloadStart}
          isDownloading={isDownloading}
          upward={upward}
          report={{ id: reportId, name: reportName }}
        />
      </Table.Cell>
    )}
  </NameDescriptionRow>
);

const mapStateToProps = ({
  datasetReports: { dataModelReports },
}, {
  category, code, reportId,
}) => {
  const report = findDataModelReport(dataModelReports, category, code, reportId);
  const download = findDataModelReport(dataModelReports, 'downloads', code, reportId, 'reportId');

  return {
    isDownloading: download?.readStatus === states.PENDING,
    reportDate: report?.created_at,
    reportName: report?.name,
    validationStatus: report?.metadata?.validation_status,
  };
};

const mapDispatchToProps = {
  downloadStart: dataModelReportDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataModelReportsTableRow);
